/* Namak Mirch: cart free-delivery progress, one-tap add-on, fixed buy bar on phones. */
(function () {
  /* Home page: the header overlays the hero, so it must start below the announcement bar. */
  var nmBar = document.querySelector('.utility-bar');
  if (nmBar) {
    var nmSetBar = function () {
      var sec = nmBar.closest('.shopify-section') || nmBar;
      document.documentElement.style.setProperty('--nm-announce-h', sec.getBoundingClientRect().height + 'px');
    };
    nmSetBar();
    window.addEventListener('resize', nmSetBar);
    window.addEventListener('load', nmSetBar);
  }

  var dataEl = document.getElementById('nm-conv-data');
  if (!dataEl) return;
  var cfg;
  try {
    cfg = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var addons = cfg.addons || [];
  var jars = {};
  var mixPrice = 0;
  addons.forEach(function (a) {
    if (a.kind === 'jar') jars[a.id] = true;
    if (a.kind === 'mix' && (!mixPrice || a.price < mixPrice)) mixPrice = a.price;
  });

  function money(cents) {
    var v = cents / 100;
    var opts = v % 1 === 0 ? {} : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return 'Rs. ' + v.toLocaleString('en-US', opts);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function pick(kind, inCart) {
    for (var i = 0; i < addons.length; i++) {
      if (addons[i].kind === kind && !inCart[addons[i].id]) return addons[i];
    }
    return null;
  }

  function build(cart) {
    var total = cart.total_price;
    var left = cfg.threshold - total;
    var pct = Math.max(4, Math.min(100, Math.round((total / cfg.threshold) * 100)));
    var inCart = {};
    var jarCount = 0;
    cart.items.forEach(function (it) {
      inCart[it.variant_id] = true;
      if (jars[it.variant_id]) jarCount += it.quantity;
    });

    var html =
      '<p class="nm-progress__msg">' +
      (left > 0
        ? 'Add <strong>' + money(left) + '</strong> more for free delivery.'
        : 'You have <strong>free delivery</strong>.') +
      '</p>' +
      '<div class="nm-progress__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';

    var item = null;
    var note = '';
    if (jarCount === 2) {
      item = pick('jar', inCart);
      note = 'Add a third jar and save ' + money(cfg.jarSave);
    } else if (left > 0) {
      item = mixPrice && left <= mixPrice ? pick('mix', inCart) || pick('jar', inCart) : pick('jar', inCart) || pick('mix', inCart);
    }

    if (item) {
      html +=
        '<div class="nm-addon">' +
        (item.image ? '<img src="' + item.image + '" alt="" width="48" height="48" loading="lazy">' : '') +
        '<div class="nm-addon__text">' +
        (note ? '<span class="nm-addon__note">' + esc(note) + '</span>' : '') +
        '<span class="nm-addon__title">' + esc(item.title) + ' · ' + money(item.price) + '</span>' +
        '</div>' +
        '<button type="button" class="nm-addon__btn" data-nm-add="' + item.id + '">Add</button>' +
        '</div>';
    }
    return html;
  }

  function mount(cart) {
    if (!cart || !cart.items) return;
    var spots = [
      document.querySelector('cart-drawer .drawer__footer'),
      document.querySelector('#main-cart-footer .cart__blocks'),
    ];
    spots.forEach(function (spot) {
      if (!spot) return;
      var box = null;
      for (var i = 0; i < spot.children.length; i++) {
        if (spot.children[i].classList.contains('nm-progress')) {
          box = spot.children[i];
          break;
        }
      }
      if (!box) {
        box = document.createElement('div');
        box.className = 'nm-progress';
        spot.insertBefore(box, spot.firstChild);
      }
      if (!cart.item_count) {
        box.hidden = true;
        box.innerHTML = '';
        box.nmHtml = '';
        return;
      }
      box.hidden = false;
      var html = build(cart);
      if (box.nmHtml !== html) {
        box.innerHTML = html;
        box.nmHtml = html;
      }
    });
  }

  function refresh() {
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(mount)
      .catch(function () {});
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  function isOwn(record) {
    var t = record.target;
    if (t.nodeType === 1 && t.closest('.nm-progress')) return true;
    if (record.removedNodes.length === 0 && record.addedNodes.length === 1) {
      var n = record.addedNodes[0];
      if (n.nodeType === 1 && n.classList.contains('nm-progress')) return true;
    }
    return false;
  }

  function watch(node) {
    if (!node || !window.MutationObserver) return;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (!isOwn(list[i])) {
          schedule();
          return;
        }
      }
    }).observe(node, { childList: true, subtree: true });
  }

  watch(document.querySelector('cart-drawer'));
  watch(document.getElementById('main-cart-footer'));
  mount(cfg.cart);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-nm-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding';

    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');
    var body = { items: [{ id: Number(btn.getAttribute('data-nm-add')), quantity: 1 }] };
    if (drawer && !onCartPage && drawer.getSectionsToRender) {
      body.sections = drawer
        .getSectionsToRender()
        .map(function (s) {
          return s.id;
        })
        .join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) {
          btn.textContent = 'Unavailable';
          return;
        }
        if (onCartPage || !drawer || !res.sections || !drawer.renderContents) {
          window.location.reload();
          return;
        }
        drawer.renderContents(res);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  });

  /* Fixed buy bar: shown on phones whenever the main Add to cart button is off screen. */
  var bar = document.getElementById('nm-sticky-atc');
  var mainSel = '.product__info-container .product-form__submit';
  if (bar && document.querySelector(mainSel)) {
    var sBtn = document.getElementById('nm-sticky-btn');
    var sPrice = document.getElementById('nm-sticky-price');
    bar.hidden = false;

    var place = function () {
      var b = document.querySelector(mainSel);
      if (!b) return;
      var r = b.getBoundingClientRect();
      var on = r.bottom < 0 || r.top > window.innerHeight;
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('nm-sticky-on', on);
    };
    var waiting = false;
    var onMove = function () {
      if (waiting) return;
      waiting = true;
      setTimeout(function () {
        waiting = false;
        place();
      }, 100);
    };
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove);
    window.addEventListener('load', place);
    place();

    sBtn.addEventListener('click', function () {
      var b = document.querySelector(mainSel);
      if (b) b.click();
    });

    var syncTimer = null;
    var sync = function () {
      var b = document.querySelector(mainSel);
      var p = document.querySelector('.product__info-container .price');
      if (p && sPrice) {
        var el = p.classList.contains('price--on-sale')
          ? p.querySelector('.price__sale .price-item--sale')
          : p.querySelector('.price__regular .price-item--regular');
        if (el && el.textContent.trim()) sPrice.textContent = el.textContent.trim();
      }
      if (b && sBtn) {
        sBtn.disabled = b.disabled;
        var label = b.querySelector('span');
        if (label && label.textContent.trim()) sBtn.textContent = label.textContent.trim();
      }
    };
    var info = document.querySelector('.product__info-container');
    if (info && window.MutationObserver) {
      new MutationObserver(function () {
        clearTimeout(syncTimer);
        syncTimer = setTimeout(sync, 80);
      }).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
    sync();
  }
})();
